export default "__VITE_ASSET__BuU_y2nc__"